import { render } from "./MessagingButton.vue?vue&type=template&id=62699eb8"
import script from "./MessagingButton.vue?vue&type=script&lang=js"
export * from "./MessagingButton.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__